module.exports = __webpack_public_path__ + "img/news26-1.a7d47532.png";